import { useCallback } from 'react';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import LandingDialog from './LandingDialog';

function LandingIncomeHelpDialog({ open, onClose }) {
    const { getLangPath } = useLangContext();
    const close = useCallback(() => onClose(), [onClose]);

    return (
        <LandingDialog
            id="income-help"
            open={open}
            onClose={close}
            className="dialog income-help-dialog"
            labelledBy="income-help-title"
        >
            <h3 id="income-help-title">{getLangPath('landing.incomeHelp.title')}</h3>
            <p>{getLangPath('landing.incomeHelp.text')}</p>
            <button className="btn" id="close-income-help" type="button" onClick={close}>
                {getLangPath('landing.incomeHelp.close')}
            </button>
        </LandingDialog>
    );
}

export default LandingIncomeHelpDialog;
